import { render, staticRenderFns } from "./Profile360Tab.vue?vue&type=template&id=70b90810&scoped=true&"
import script from "./Profile360Tab.vue?vue&type=script&lang=js&"
export * from "./Profile360Tab.vue?vue&type=script&lang=js&"
import style0 from "./Profile360Tab.vue?vue&type=style&index=0&id=70b90810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b90810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VIcon,VSkeletonLoader})
